import * as Yup from 'yup'


/** Dropoff Consignment Inbound Request Receiving schema for Non-Exclusive Seller (have maximum quantity) */
const consignmentInboundRequestReceiveDropoffSchema = Yup.object().shape({
  received_quantity: Yup.number()
    .positive('Must be more than 0')
    .required('Required'),
  received_weight: Yup.number().positive('Must be more than 0').required('Required')
})

export default consignmentInboundRequestReceiveDropoffSchema
